// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2pQob","description":"PatientConsentPreview_description__2bWnW"};